export class SearchComplianceProposalModel {
    startDate: string;
    endDate: string;
    institution: string;
    serviceContract: string;
    cpfCnpj: string;
    status: string;
    page: string;
    size: string;
}
